import { ICON__circle_question } from '@/assets/icons_fa';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { useState } from 'react';

interface PROPS {
  field: FIELD__base;
  info_at_begin?: MAP__serializable<string, string>;
}

export function G_UI_FIELD__info({ field, info_at_begin = new MAP__serializable() }: PROPS) {
  const [is_hovered, set_is_hovered] = useState(false);

  /*
   * RENDERS
   */

  function render_row(name: string, value: string) {
    return (
      <div key={`${name}_${value}`} className="flex justify-between border-b border-component-border border-dashed last:border-0">
        <span className="font-semibold text-bar-foreground text-left text-xs whitespace-nowrap truncate max-w-[25%]">{name}</span>
        <span className="font-mono text-component-item-foreground text-right  text-xs break-all truncate max-w-[75%]">{value}</span>
      </div>
    );
  }

  function render_info_at_begin() {
    if (info_at_begin.is_empty()) return null;

    let out = [];

    for (let [key, value] of info_at_begin.entries()) {
      out.push(render_row(key, value));
    }

    return out;
  }

  function render_content() {
    if (!is_hovered) return null;

    return (
      <div className="absolute translate-y-full left-1/2 bottom-full flex flex-col bg-bar rounded-lg px-2 py-1 z-50 w-56 border border-component-border pointer-events-none">
        {render_info_at_begin()}
        {render_row('Node', field.meta.node_type)}
        {render_row('Path', field.meta.field_path)}
        {render_row('Kind', field.meta.field_kind)}
        {render_row('Id Node', field.meta.node_id)}
        {render_row('Id Field', field.meta.field_id)}
        {render_row('Hash', field.meta.field_hash__value_full)}
        {field.meta.ui__is_readonly && render_row('', 'Read Only')}
        {field.meta.data__is_linked && render_row('', 'Linked')}
      </div>
    );
  }

  /*
   * HTML
   */

  return (
    <div className="relative inline-block" onMouseEnter={() => set_is_hovered(true)} onMouseLeave={() => set_is_hovered(false)}>
      <ICON__circle_question className="size-3 text-gray-500  cursor-pointer transition-colors duration-200" />

      {render_content()}
    </div>
  );
}
